<template>
  <div id="shopadmin" class="w100m h100m bg-fff-color pad10_t">
    <div class="Title bg-white f18 pad20">店铺管理--分类管理</div>
    <div class="bg-white pad20_lr">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="分类管理" name="classify"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="flex bg-white flex-end pad20">
      <el-button type="primary" @click="createclass(1)">添加分类</el-button>
    </div>
    <div class="bg-white pad20_lr flex align-center">
      <img src="./images/tishi.png" alt="" />
      <p class="mar10_l c_gray6">温馨提示：货品分类最多只能设置十个哦</p>
    </div>
    <div class="bg-white pad20">
      <div class="mar20_b flex">
        <div
          class="w20m flex align-center flex-center bg-d6d6d6 pad10_tb"
          v-for="(item, index) in tabhead"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="border">
        <div
          class="flex"
          :class="index + 1 != tablecont.length ? 'border_b' : ''"
          v-for="(item, index) in tablecont"
          :key="index"
        >
          <div class="w20m pad20_tb flex align-center flex-center">
            {{ item.site }}
          </div>
          <div class="w20m pad20_tb flex align-center flex-center">
            {{ item.navigation }}
          </div>
          <div class="w20m pad20_tb flex align-center flex-center">
            {{ item.commoditynum }}
          </div>
          <div class="w20m pad20_tb flex align-center flex-center">
            <p v-if="index != 0" class="mar5_lr pointer">上移</p>
            <p class="mar5_lr pointer" v-if="index + 1 != tablecont.length">
              下移
            </p>
          </div>
          <div class="w20m pad20_tb flex align-center flex-center">
            <p class="mar5_lr pointer" @click="createclass(2, item)">编辑</p>
            <p class="mar5_lr pointer" @click="delet(item)">删除</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
      <div class="flex align-center">
        <div class="flex w100"><span class="theme-color">*</span>分类名称</div>
        <el-input v-model="value" placeholder="请输入内容"></el-input>
      </div>
      <div class="flex flex-center mar20_t">
        <el-button class="bg-white c_gray3 border-e3">取消</el-button>
        <el-button type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "shopadmin",
  data() {
    return {
      activeName: "classify",
      title: "添加分类",
      dialogVisible: false,
      value: "",
      tabhead: ["位置", "导航名称", "商品数", "移动", "操作"], // 表格头
      tablecont: [
        // 表格内容
        { site: "位置", navigation: "200", commoditynum: "100" },
        { site: "位置", navigation: "200", commoditynum: "100" },
        { site: "位置", navigation: "200", commoditynum: "100" },
        { site: "位置", navigation: "200", commoditynum: "100" },
        { site: "位置", navigation: "200", commoditynum: "100" },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    createclass(type, item) {
      console.log(item);
      //   this.title = "添加分类"
      this.value = item ? item.navigation : "";
      this.title = type == 1 ? "添加分类" : "编辑分类";
      this.dialogVisible = !this.dialogVisible;
    },
    delet(item) {
      this.$confirm("确定删除该分类吗？", "删除分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
</style>
